import {MainHelper} from "./main-helper";
import {CodeName} from "../../stocks/models/code-name";

export class CodeNameTranslate extends CodeName{
    constructor(id: number, selected: boolean, code: any, name: string, public readonly key: string){
        super(id, selected, code, name);
    }

    public clone = (): CodeNameTranslate => {
        let clone = new CodeNameTranslate(this.id, this.selected, this.code, this.name, this.key);
        clone.findName = this.findName;
        clone.findCode = this.findCode;
        return clone;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/code-name-translate.ts